import { Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_conversion-labs-6/artifacts/qzhea8b5_WhatsApp%20Image%202026-04-23%20at%2010.14.46%20AM.jpeg";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-slate-950/80" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 py-10 md:grid-cols-3 md:items-start md:px-6">
        {/* Brand */}
        <div className="flex items-start gap-3">
          <img
            src={LOGO_URL}
            alt="Markite"
            className="h-10 w-auto ring-1 ring-white/10"
          />
          <div>
            <div className="text-xs text-slate-400">
              A product of <span className="font-semibold text-white">KAGAV TECHNOLOGIES LLP</span>
            </div>
            <div className="mt-1 text-[11px] text-slate-500">© 2026 KAGAV TECHNOLOGIES LLP · All rights reserved.</div>
          </div>
        </div>

        {/* Office address */}
        <div className="flex items-start gap-2 text-sm text-slate-400">
          <MapPin className="mt-0.5 h-4 w-4 flex-none text-blue-400" />
          <div>
            <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">
              Office
            </div>
            <p className="mt-1 text-sm leading-relaxed text-slate-300" data-testid="footer-address">
              Sector 6, HSR Layout,<br />
              Bengaluru, Karnataka 560102
            </p>
          </div>
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-2 text-sm text-slate-400 md:items-end">
          <a
            href="mailto:markite.advertise@gmail.com"
            className="inline-flex items-center gap-2 transition-colors hover:text-white"
            data-testid="footer-email"
          >
            <Mail className="h-4 w-4" /> markite.advertise@gmail.com
          </a>
          <a
            href="tel:+919972579453"
            className="inline-flex items-center gap-2 transition-colors hover:text-white"
            data-testid="footer-phone"
          >
            <Phone className="h-4 w-4" /> +91 99725 79453
          </a>
        </div>
      </div>

      {/* Payments trust strip */}
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-5 py-4 md:flex-row md:px-6" data-testid="razorpay-strip">
          <div className="flex items-center gap-3">
            <span className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">
              Payments by
            </span>
            <img
              src="https://cdn.razorpay.com/static/assets/logo/payment.svg"
              alt="Razorpay"
              className="h-5 w-auto opacity-90"
              onError={(e) => { e.currentTarget.src = "https://razorpay.com/build/browser/static/razorpay-glyph.5cb6c69e.svg"; }}
            />
          </div>
          <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-slate-400">
            <span>Secure</span>
            <span className="text-slate-600">|</span>
            <span>Fast</span>
            <span className="text-slate-600">|</span>
            <span>Trusted payments</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
